import {
  call, put, takeEvery, takeLatest,
} from 'redux-saga/effects';

import { AppConfiguration } from 'config';
import { getCurrentBrandFromLocalStorage } from 'helpers/sf_utils';
import { getCurrentUser } from 'store/actions';
import {
  GET_PAYMENT_METHODS,

  GET_BILLING_REPORT,
  INITIATE_CARD_UPDATE,
  COMPLETE_CARD_UPDATE,
  CANCEL_CARD_UPDATE,
  COMPLETE_CARD_UPDATE_2,

} from './actionTypes';

import {
  getPaymentMethodsSuccess,
  getPaymentMethodsError,
  getBillingReportSuccess,
  getBillingReportError,
  initiateCardUpdateSuccess,
  initiateCardUpdateError,
  completeCardUpdateSuccess,
  completeCardUpdateError,
  cancelCardUpdateSuccess,
  cancelCardUpdateError,
  completeCardUpdate_2Success,
  completeCardUpdate_2Error

} from './actions';

import {
  fetchReport,
  genericGetRequest, genericPostRequest,
} from '../../helpers/sf_backend_helper';

function* onGetPaymentMethods() {
  try {
    const { user } = JSON.parse(localStorage.getItem('authUser'));
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/get_payment_methods`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'account-id': user.account_id,
      },
    );
    yield put(getPaymentMethodsSuccess(response));
  } catch (error) {
    yield put(getPaymentMethodsError(error));
  }
}

function* onInitiateUpdate() {
  try {
    const { user } = JSON.parse(localStorage.getItem('authUser'));
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/initiate_card_update`,
      {
        body: JSON.stringify({

        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
        },
      },
    );

    yield put(initiateCardUpdateSuccess(response));
    yield put(getCurrentUser())
  } catch (error) {
    yield put(initiateCardUpdateError(error));
  }
}

function* onCompleteCardUpdate(payload) {
  try {
    const { user } = JSON.parse(localStorage.getItem('authUser'));
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/complete_card_update`,
      {
        body: JSON.stringify({
          payment_method: payload.payload,
        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
        },
      },
    );

    yield put(completeCardUpdateSuccess(response));
    window.location.reload();
  } catch (error) {
    yield put(completeCardUpdateError(error));
  }
}


function* onCompleteCardUpdate_2(payload) {
  try {
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/complete_card_update_2`,
      {
        body: JSON.stringify({
          payment_method: payload.payload.paymentMethod,
          user_id: payload.payload.user_id,
          initial_deposit: payload.payload.initial_deposit
        }),
        headers: {

          'Content-Type': 'application/json',
        },
      },
    );

    yield put(completeCardUpdate_2Success(response));
    window.location = '/login'
  } catch (error) {
    yield put(completeCardUpdate_2Error(error));
  }
}

function* onCardUpdateCancel() {
  try {
    const { user } = JSON.parse(localStorage.getItem('authUser'));
    const response = yield call(
      genericPostRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/cancel_card_update`,
      {
        body: JSON.stringify({

        }),
        headers: {
          Authorization: user.token,
          'account-id': user.account_id,
          'Content-Type': 'application/json',
        },
      },
    );

    yield put(cancelCardUpdateSuccess(response));
    window.location.reload();
  } catch (error) {
    yield put(cancelCardUpdateError(error));
  }
}

function* onGetBillingReport(action) {
  try {
    const { user } = JSON.parse(localStorage.getItem('authUser'));
    let endpoint = `/api/v1/get_billing_report_by_month?month=${action.payload.month}&year=${action.payload.year}&invoice_id=${action.payload.invoice_id}`
    if (action.payload.billing_setting_invoice_change_flag_active){
      endpoint = endpoint + `&type=${action.payload.type}`
    }
    if (action.payload.use_bill_com) {
      endpoint = `/api/v1/bill_com_invoices/${action.payload.invoice_id}/download`
    }
    const response = yield call(
      fetchReport,
      `${AppConfiguration.BACKEND_URL}${endpoint}`,
      {
      },
      {
        Authorization: user.token,
        'account-id': user.account_id,
        'brand-id': action.payload?.rtbPayload?.show_rtb_brand_ui_changes ? action.payload?.rtbPayload?.brand_id :  getCurrentBrandFromLocalStorage()?.id

      },
    );
    yield put(getBillingReportSuccess(response));
  } catch (error) {
    yield put(getBillingReportError(error));
  }
}
function* PaymentMethodsSaga() {
  yield takeEvery(GET_PAYMENT_METHODS, onGetPaymentMethods);
  yield takeLatest(INITIATE_CARD_UPDATE, onInitiateUpdate);
  yield takeLatest(COMPLETE_CARD_UPDATE, onCompleteCardUpdate);
  yield takeLatest(COMPLETE_CARD_UPDATE_2, onCompleteCardUpdate_2);

  yield takeEvery(GET_BILLING_REPORT, onGetBillingReport);
  yield takeLatest(CANCEL_CARD_UPDATE, onCardUpdateCancel);
}

export default PaymentMethodsSaga;
